import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles({
  PlanosAlertaModal: {
    "& .MuiDialogTitle-root": {
      padding: "0px 10px"
    },
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "480px"
    }
  },
  PlanosAlertaModalHeader: {
    display: "flex",
    alignItems: "center",
    paddingTop: "1rem",
    width: "100%",
    "& h2": {
      textAlign: "center",
      margin: 0,
      padding: 0,
      fontSize: "80%",
      flex: 1
    },
    "& button": {
      width: "10%",
      margin: 0,
      padding: 0,
      border: "none",
      backgroundColor: "transparent"
    }
  },
  PlanosAlertaModalBody: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& p": {
      fontSize: "100%",
      fontWeight: "300",
      textAlign: "center"
    },
    "& span": {
      color: "#EA3458",
      fontWeight: "600"
    },
    "& img": {
      width: "100%",
      maxWidth: "170px",
      margin: "10px 0"
    }
  }
})
export default useStyles
